





































































































































import {
  Vue
} from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";
import GoogleLogin from "vue-google-login";

export default Vue.component("app-signup", {
  components: {
    GoogleLogin,
  },
  data() {
    return {
      name: null,
      email: null,
      password: null,
      staticContent,
      params: {
        clientId:
          "624762958330-ildvq3irtcuuh82oufi3macui8vns7bo.apps.googleusercontent.com",  // dev, testing and production
      },
      renderParams: {
        width: 250,
        height: 50,
        longtitle: true,
      },
    };
  },
  props: {
    hideFacebook: {
      type: Boolean,
      required: false,
    },
    reload: {
      type: Boolean,
      required: false,
    },
      reOrder: {
      type: Boolean,
      required: false,
    },
    
  },
  computed: {
    isValid(){
      return this.name && this.email && this.password
    },
    signupErrors() {
      return this.$store.getters.getSignupErrors;
    },
    signupLoading() {
      return this.$store.getters.getSignupLoading;
    },
  },
  methods: {
    onSuccess(googleUser) {
      // This only gets the user information: id, name, imageUrl and email
      let profile = googleUser.getBasicProfile();
      const data = {
        id: profile.getId(),
        name: profile.getName(),
        email: profile.getEmail(),
        token: googleUser.getAuthResponse().id_token,
      }
      this.$store.dispatch('googleLogin', [data,this.reOrder]);
    },
    onFailure(error) {
      console.log(error);
    },
    submitSignupForm(reload,reOrder) {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.$store.dispatch("signup", {
            data: {
              body: {
                name: this.name,
                email: this.email,
                password: this.password,
              },
              reload: reload,
              reOrder:reOrder
            },
          });
        }
      });
    },
  },
});
